import React from 'react';
// eslint-disable-next-line import/no-cycle
import {LinkedValueSearch} from 'feature/linkedValueSearch/LinkedValueSearch';
import {useLinkedValueSearchFieldContext} from './hooks';
import {useLinkedValueSearchPageConfigContext} from './hooks/useLinkedValueSearchPageConfigContext';

export const LinkedValueSearchContainer: React.FC = () => {
  const {
    sourceField,
    hasChanges,
    setHasChanges,
    setSourceValue,
    closeExtension,
  } = useLinkedValueSearchFieldContext();

  const pageConfigContext = useLinkedValueSearchPageConfigContext();

  return (
    <LinkedValueSearch
      fieldId={sourceField?.fieldId ?? ''}
      sourceConfig={sourceField?.fieldConfig}
      sourceValue={sourceField?.currentValue}
      onSetSourceValue={setSourceValue}
      pageConfigContext={pageConfigContext}
      hasChanges={hasChanges}
      setHasChanges={setHasChanges}
      onClose={closeExtension}
    />
  );
};
